import { useEffect, useState } from "react";
import { globalVariables } from "helper/globalVariables";
import {
  Member,
  CalendarIcon,
  CheckVerified,
  ClockRewind,
  logo,
  menu,
  avatar,
  Logout,
  SwitchRole,
} from "helper/images";
import { Magnifier } from "helper/icons";
import { Link, useLocation } from "react-router-dom";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import { useDispatch } from "react-redux";
import {
  setAuthToken,
  setOriginalRoleAction,
  setRoleAction,
  setUser,
} from "redux/features/authSlice/AuthSlice";
import { useSelector } from "react-redux";
import { setMemberDetails } from "redux/features/memberSlice/memberSlice";
import {
  setHostDetails,
  setTrialDetails,
} from "redux/features/hostSlice/addTrialSlice/addTrialSlice";

export const MobileHeader = (props) => {
  const route = useLocation();
  const dispatch = useDispatch();
  const [switchRoleInActive, setswitchRoleInActive] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const profile = useSelector(
    (state) => state.auth?.memberReducer?.memberDetails?.profile
  );

  const toggleDrawer = () => {
    setIsOpen(!isOpen);
  };
  
  const params = new URLSearchParams(window.location.search);
  const option = params.get("option");
  useEffect(() => {
    if (option === "switchRole") {
      setswitchRoleInActive(true);
    } else {
      setswitchRoleInActive(false);
    }
  }, [route.pathname]);
  const sideNavData = [
    {
      icon: <Member className="h-6 w-6 mr-3" />,
      label: globalVariables.myDashboard,
      navigate: "/dashboard/memberDashboard",
    },
    {
      icon: <CalendarIcon className="h-6 w-6 mr-3" />,
      label: globalVariables.trialCalendar,
      navigate: "/dashboard/trialCalendar",
    },
    {
      icon: <CheckVerified className="h-6 w-6 mr-3" />,
      label: globalVariables.trialResults,
      navigate: "/dashboard/trialResults",
    },
    {
      icon: <ClockRewind className="h-6 w-6 mr-3" />,
      label: globalVariables.dogHistory,
      navigate: "/dashboard/dogHistory",
    },
    {
      icon: <Magnifier className="h-6 w-6 mr-3" />,
      label: globalVariables.viewEntries,
      navigate: "/dashboard/viewEntries",
    },
    {
      icon: <SwitchRole className="h-6 w-6 mr-3" />,
      label: "Switch-Roles",
      navigate: "/dashboard/switchRole?option=switchRole",
      active: "/dashboard/myProfile?option=switchRole",
    },
  ];

  const { menuItems = sideNavData, profileRoute, noProfile } = props || {};

  const onLogout = () => {
    dispatch(setUser(null));
    dispatch(setAuthToken(""));
    dispatch(setMemberDetails(null));
    dispatch(setHostDetails(null));
    dispatch(setTrialDetails(null));
    dispatch(setRoleAction(""));
    dispatch(setOriginalRoleAction(""));
  };

  const ProfileComponent = () => {
    const [profileImg, setProfileImg] = useState(profile);

    useEffect(() => {
      setProfileImg(profile);
    }, [profile]);

    return (
      <div className="md:ml-auto">
        <img
          src={profileImg ? profileImg : avatar}
          alt="Profile"
          className="w-7 mb-3 mt-6 mr-3 rounded-full"
          onError={() => {
            setProfileImg(avatar);
          }}
        />
      </div>
    );
  };

  return (
    <>
      <div className="flex justify-between items-center bg-white md:flex-row md:flex-wrap z-10">
        <div className="md:ml-6">
          <button onClick={toggleDrawer}>
            <img src={menu} alt="" className="w-4  ml-3" />
          </button>
        </div>
        <div className="md:ml-6">
          <a href="https://www.k9scentgames.fun" target="_blank" rel="noopener noreferrer">
            <img src={logo} alt="Logo" width={80} className="mb-3 mt-3 cursor-pointer" />
          </a>
        </div>
        {!noProfile ? (
          <Link
            to={profileRoute ? profileRoute : "/dashboard/myProfile"}
            className="flex"
          >
            <div className="cursor-pointer">
              <ProfileComponent />
            </div>
          </Link>
        ) : (
          <div className="flex">
            <ProfileComponent />
          </div>
        )}
      </div>
      <Drawer open={isOpen} onClose={toggleDrawer} direction="left">
        <div
          className="fixed h-full bg-white text-white"
          style={{ width: "280px" }}
        >
          <img
            src="https://www.svgrepo.com/show/506172/cross.svg"
            alt=""
            className="w-5  mt-3 ml-auto mr-4 "
            onClick={() => setIsOpen(false)}
          />
          <div className="py-8 px-4">
            <ul>
              {menuItems.map((data, index) => (
                <li
                  key={data.label}
                  className="hover:stroke-white stroke-purple-900 mb-1 py-2 px-3 h-10 cursor-pointer bg-gradient-to-r bg-white text-purple-900 hover:from-gradient-300 hover:via-gradient-500 hover:to-gradient-600 rounded-md hover:text-white text-base font-semibold"
                >
                  <Link to={data.navigate}>
                    <div className="flex flex-row">
                      {data.icon}
                      <span onClick={() => setIsOpen(!isOpen)}>
                        {data.label}
                      </span>
                    </div>
                  </Link>
                </li>
              ))}
              <li
                className="hover:stroke-white stroke-purple-900 mb-1 py-2 px-3 h-10 cursor-pointer bg-gradient-to-r bg-white text-purple-900 hover:from-gradient-300 hover:via-gradient-500 hover:to-gradient-600 rounded-md hover:text-white text-base font-semibold"
                onClick={() => {
                  setIsOpen(false);
                  onLogout();
                }}
              >
                <div className="flex flex-row">
                  <Logout className="h-6 w-6 mr-3" />
                  <span>Logout</span>
                </div>
              </li>
            </ul>
          </div>
          <div className="absolute bottom-8 mx-4 px-2">
            <button
              className="flex flex-row justify-center items-center"
              onClick={onLogout}
            >
              <Logout />
              <span className="font-semibold text-primary pl-1 text-xl">
                Logout
              </span>
            </button>
          </div>
        </div>
      </Drawer>
    </>
  );
};
